module.exports = __webpack_public_path__ + "static/media/ApercuPro-Light.cda9f6e6.woff";